import styled from 'styled-components';

import ButtonLink from '../interface/ButtonLink';
import Container from '../interface/Container';

export const CtaWrapper = styled.div`
  margin-top: 4rem;

  @media (${({ theme }) => theme.respondTo.desktopL}) {
    margin: 0 0 1rem 3rem;
  }
`;

export const ImageOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%);
  position: absolute;
  top: 0;
  left: 0;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 60rem;
  position: absolute;

  > * {
    width: 100%;
    height: 100%;
    border-top-right-radius: 12rem;

    @media (${({ theme }) => theme.respondTo.tablet}) {
      border-top-right-radius: 24rem;
    }
  }
`;

export const Split = styled.div`
  @media (${({ theme }) => theme.respondTo.desktopL}) {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
`;

export const StyledButtonLink = styled(ButtonLink)`
  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 100%;
    text-align: center;
  }
`;

export const StyledContainer = styled(Container)`
  position: relative;
  padding-bottom: 6rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-bottom: 13.5rem;
  }
`;

export const Title = styled.h4`
  color: var(--color-text-light);
  font-family: var(--font-secondary);
  font-weight: var(--font-weight-regular);
  font-size: 4.2rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 6.4rem;
    max-width: 70rem;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 60rem;
`;
